<div class="create-education create-education-two">
    <div class="create-education-wrap">
        <div class="create-education-left">
            <h2>Experiencia</h2>
        </div>

        <div class="create-education-right">
            <a (click)="mostrarEdicionExperiencia()">+ Añadir Experiencia</a>
        </div>
    </div>

    <div>
        <div class="container" *ngIf="!mostrarEdicion">
            <div class="row" *ngFor="let experiencia of experiencias  | paginate: { itemsPerPage: 1, currentPage: noPagina }">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Nombre de la Empresa</label>
                        <input type="text" class="form-control" [value]="experiencia.empresaLaborada" readonly>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Descripción</label>
                        <textarea class="form-control" style="height: 80px;" [value]="experiencia.descripcion" readonly></textarea>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="form-group">
                      <label>Año Inicio</label>
                      <input type="text" class="form-control" [value]="experiencia.fechaInicio" readonly>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="form-group">
                      <label>Año Fin</label>
                      <input type="text" class="form-control" [value]="experiencia.fechaFin" readonly>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="form-group">
                        <div class="form-check">
                            <input *ngIf="!disableAnioFin" class="form-check-input" type="checkbox" id="flexCheckDefault" (change)="inhabilitarCampoAnioFin()" [disabled]="true">
                            <input *ngIf="disableAnioFin" class="form-check-input" type="checkbox" id="flexCheckDefault" checked (change)="inhabilitarCampoAnioFin()" [disabled]="true">
                            <label class="form-check-label">
                                Actual
                            </label>
                        </div>
                    </div>
                </div>

                <div class="col-lg-12">
                    <div class="form-group">
                        <div class="text-left">
                            <button type="button" class="btn btn-default-ac" (click)="habilitarEdicion(experiencia)">Editar Actual</button>
                            <button type="button" class="btn btn-default-ac" (click)="eliminarExperienciaCandidato(experiencia.idExperiencia)">Eliminar Actual</button>
                        </div>
                    </div>
                </div>

                <div class="aling-center">
                    <pagination-controls class="page-numbers" (pageChange)="noPagina = $event" (pageChange)="cambioPaginaExperiencia()"
                        [responsive]="true" [previousLabel]="''" [nextLabel]="''"></pagination-controls>
                </div>
            </div>
        </div>

        <div class="container" *ngIf="mostrarEdicion">
            <form [formGroup]="formExp" (ngSubmit)="validarExperiencia()">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Nombre de la Empresa</label>
                            <input type="text" class="form-control" formControlName="empresaLaborada" [placeholder]="experienciaCandidato.empresaLaborada || 'Tec Gurus'">
                            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formExp.controls.empresaLaborada.errors &&
                                (formExp.controls.empresaLaborada.dirty || formExp.controls.empresaLaborada.touched)">
                                <div *ngIf="formExp.controls.empresaLaborada.errors.required">El nombre de la empresa laborada es requerida.</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Describe un breve párrafo sobre tus actividades realizadas.</label>
                            <textarea class="form-control" formControlName="descripcion" [placeholder]="experienciaCandidato.descripcion || 'Desarrolar con el patrón de diseño MVC...'" style="height: 80px;"></textarea>
                            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formExp.controls.descripcion.errors &&
                                (formExp.controls.descripcion.dirty || formExp.controls.descripcion.touched)">
                                <div *ngIf="formExp.controls.descripcion.errors.required">La descripción es requerida.</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="form-group">
                            <label>Año Inicio</label>
                            <input type="text" maxlength="4" class="form-control" formControlName="fechaInicio" [placeholder]="experienciaCandidato.fechaInicio || 'Año inicio'">
                            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formExp.controls.fechaInicio.errors &&
                                (formExp.controls.fechaInicio.dirty || formExp.controls.fechaInicio.touched)">
                                <div *ngIf="formExp.controls.fechaInicio.errors.pattern">Solo se permiten números.</div>
                                <div *ngIf="formExp.controls.fechaInicio.errors.maxlength">El año inicio solo debe contener como máximo 4 dígitos.</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="form-group">
                            <label>Año Fin</label>
                            <input type="text" maxlength="4" class="form-control" formControlName="fechaFin" [placeholder]="experienciaCandidato.fechaFin || 'Año fin'" [readonly]="disableAnioFin">
                            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formExp.controls.fechaFin.errors &&
                                (formExp.controls.fechaFin.dirty || formExp.controls.fechaFin.touched)">
                                <div *ngIf="formExp.controls.fechaFin.errors.pattern">Solo se permiten números.</div>
                                <div *ngIf="formExp.controls.fechaFin.errors.maxlength">El año inicio solo debe contener como máximo 4 dígitos.</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="form-group">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" [value]="" id="flexCheckDefault" (change)="inhabilitarCampoAnioFin()" *ngIf="!disableAnioFin">
                                <input class="form-check-input" type="checkbox" [value]="" id="flexCheckDefault" checked (change)="inhabilitarCampoAnioFin()" *ngIf="disableAnioFin">
                                <label class="form-check-label" for="flexCheckDefault">
                                    Actual
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12">
                        <div class="form-group">
                            <div class="text-left">
                                <button type="submit" class="btn create-ac-btn">{{(editarExperiencia ? 'Actualizar' : 'Agregar')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
